import { render, staticRenderFns } from "./single-employee.vue?vue&type=template&id=054c8014&"
import script from "./single-employee.vue?vue&type=script&lang=js&"
export * from "./single-employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports